<template>
  <v-card
    v-show="mostrar"
    justify="center"
    color="rgb(255, 255, 255, 0.5)"
    outlined
  >
    <v-container fluid>
      <v-row dense>
        <v-col>
          <v-card color="rgb(255, 0, 0, 0)" outlined>
            <v-img
              contain
              max-height="18.75rem"
              src="@/assets/logomyplanilla.png"
            ></v-img>
          </v-card>
        </v-col>
        <v-col>
          <v-card :disabled="form.deshabilita">
            <v-toolbar flat color="primary" dark>
              <v-toolbar-title>{{ compTitulo }}</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>

            <v-card-text>
              <v-form ref="form" v-model="form.valid" lazy-validation>
                <v-container>
                  <v-row>
                    <v-col cols="12" md="12" class="pa-1 px-3">
                      <v-text-field
                        autofocus
                        label="Usuario"
                        counter="true"
                        v-model="defaultItem.usuario"
                        :rules="[
                          () => !!defaultItem.usuario || 'El campo es requerido',
                        ]"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12" class="pa-1 px-3">
                      <v-text-field
                        label="Password"
                        v-model="defaultItem.password"
                        maxlength="100"
                        :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="show1 ? 'text' : 'password'"
                        :rules="[
                          () =>
                            !!defaultItem.password || 'El campo es requerido',
                        ]"
                        @click:append="show1 = !show1"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-card-text>

            <v-card-actions class="px-9 py-3">
              <v-row>
                <v-btn
                  class="mb-3"
                  color="green darken-1"
                  block
                  dark
                  rounded
                  :loading="btnIngresar.loading"
                  @click="btnIngresarClick"
                  >Iniciar Sesión</v-btn
                >
              </v-row>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-snackbar
      v-model="mensaje.snack"
      :timeout="mensaje.tiempo"
      :color="mensaje.snackColor"
      top
      right
    >
      {{ mensaje.snackText }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="mensaje.snack = false">
          <v-icon dark>mdi-close-box</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
import axios from "axios";

export default {
  name: "Iniciar",
  components: {},
  data: () => ({
    show1: false,
    mostrar: true,
    mensaje: {
      snack: false,
      snackColor: "",
      snackText: "",
      tiempo: 2000,
    },
    rules: {
      email: (value) => {
        const pattern =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "E-mail invalido";
      },
    },
    btnIngresar: {
      loading: false,
    },
    form: {
      valid: true,
      deshabilita: false,
    },
    defaultItem: {
      email: null,
      usuario: null,
      password: null,
    },
  }),
  computed: {
    compTitulo() {
      return "Acceso al Sistema";
    },
  },
  methods: {
    limpiar() {
      this.defaultItem.usuario = null;
      this.defaultItem.email = null;
      this.defaultItem.password = null;
      this.$refs.form.resetValidation();
    },
    APIingresar(val) {
      return new Promise((resolve, reject) => {
        axios
          .post("api/LogIn/LogIn", {
            usuario: val.usuario,
            password: val.password,
          })
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    async btnIngresarClick() {
      try {
        if (!this.$refs.form.validate()) {
          return;
        }
        this.btnIngresar.loading = true;
        this.form.deshabilita = true;
        let data = {
          usuario: this.defaultItem.usuario,
          password: this.defaultItem.password,
        };
        const respuesta = await this.APIingresar(data);
        if (respuesta) {
          this.$store.dispatch("guardarToken", respuesta.token);
          this.$router.push({ name: "Home" });
        }
      } catch (error) {
        if (error.response === null || error.response === undefined) {
          this.mensaje.snackColor = "grey darken-4";
          this.mensaje.snackText = error;
          this.mensaje.snack = true;
        } else {
          this.mensaje.snackColor = "red darken-4";
          this.mensaje.snackText = await this.$store.dispatch(
            "errorMensaje",
            error.response
          );
          this.mensaje.snack = true;
        }
      } finally {
        this.form.deshabilita = false;
        this.btnIngresar.loading = false;
      }
    },
  },
};
</script>

